import { buildTimeDuration } from './buildTimeDuration';

/**
 * Given number of miliseconds, returns the iso8601 string rounded down from
 * number of seconds. Mainly copied from https://github.com/wistia/player-modern/blob/master/src/utilities/iso8601Helper.js#L54
 * but modified to support milliseconds
 *
 * @param {number} numberOfMilliseconds - number of milliseconds
 * @returns {string} an iso8601 string format of duration
 */
export const millisecondsToDurationISOString = (numberOfMilliseconds: number): string => {
  const { seconds, minutes, hours } = buildTimeDuration(numberOfMilliseconds);

  let string = 'PT';

  if (hours) {
    string += `${hours}H`;
  }

  if (minutes) {
    string += `${minutes}M`;
  }

  if (seconds) {
    string += `${seconds}S`;
  }

  if (!(seconds || minutes || hours)) {
    string += '0S';
  }

  return string;
};
